<template>
  <div>
    <el-form :model="dimensionRule" ref="dimensionRule" label-position="top">
      <div class="price-range-row">
        <span>Regras de Dimensões</span>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('dimensao-max')">
              <el-input-number v-model="dimensionRule.dimensionLimit" :min="0" :controls="false" :precision="2" :rules="[
                { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                { type: 'number', message: $t('numero'), trigger: 'blur' }
              ]" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('valor-a-cobrar')">
              <el-input-number v-model="dimensionRule.sizeLimitIncrement" :min="0" :controls="false" :precision="2"
                :rules="[
                  { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                  { type: 'number', message: $t('numero'), trigger: 'blur' }
                ]" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('dimensao-total-max')">
              <el-input-number v-model="dimensionRule.dimensionTotalLimit" :min="0" :controls="false" :precision="2"
                :rules="[
                  { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                  { type: 'number', message: $t('numero'), trigger: 'blur' }
                ]" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('valor-a-cobrar')">
              <el-input-number v-model="dimensionRule.sizeLimitTotalIncrement" :min="0" :controls="false" :precision="2"
                :rules="[
                  { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                  { type: 'number', message: $t('numero'), trigger: 'blur' }
                ]" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="price-range-row">
        <span>Peso Adicional</span>
        <el-button type="primary" @click="addPriceRange" style="float: right;margin-top: -5px" icon="el-icon-plus"
          circle />
        <div v-for="(range, index) in dimensionRule.priceRanges" :key="index" class="price-range-row">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('peso-min-g')" :prop="'priceRanges.' + index + '.minWeight'" :rules="[
                { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                { type: 'number', message: $t('numero'), trigger: 'blur' }
              ]">
                <el-input-number v-model="range.minWeight" :min="0" :controls="false" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$t('valor-a-cobrar')" :prop="'priceRanges.' + index + '.addValue'" :rules="[
                { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                { type: 'number', message: $t('numero'), trigger: 'blur' }
              ]">
                <el-input-number v-model="range.addValue" :min="0" :controls="false" :precision="2"
                  class="w-full"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="8" class="centered-col">
              <el-button type="danger" icon="el-icon-delete" @click="removePriceRange(index)" circle />
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ShippingAddFormDynamicPrice',
  data() {
    return {
      dimensionRule: {
        priceRanges: []
      }
    }
  },
  methods: {
    addPriceRange() {
      this.dimensionRule.priceRanges.push({
        minWeight: 0,
        addValue: 0
      })
    },
    removePriceRange(index) {
      this.dimensionRule.priceRanges.splice(index, 1)
    },
    setData(data) {
      const { dimensionRules } = data;
      if (dimensionRules) {
        this.dimensionRule = {
          dimensionLimit: dimensionRules.dimensionLimit,
          sizeLimitIncrement: dimensionRules.sizeLimitIncrement,
          dimensionTotalLimit: dimensionRules.dimensionTotalLimit,
          sizeLimitTotalIncrement: dimensionRules.sizeLimitTotalIncrement,
          priceRanges: dimensionRules.priceRange
        }
      }
    },
    data() {
      return {
        dimensionRules: {
          priceRange: [...this.dimensionRule.priceRanges],
          dimensionLimit: this.dimensionRule.dimensionLimit,
          sizeLimitIncrement: this.dimensionRule.sizeLimitIncrement,
          dimensionTotalLimit: this.dimensionRule.dimensionTotalLimit,
          sizeLimitTotalIncrement: this.dimensionRule.sizeLimitTotalIncrement,
        }
      };
    },
  }
}
</script>

<style scoped>
.price-range-row {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}

.centered-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 90px;
}
</style>
